export default __webpack_public_path__ + "static/tishman-speyer-954053b1251153aa38871e39b481f630.svg";